import { Checkbox, FormControlLabel } from "@mui/material";
import { useIsCredentialRequirementConfigurationEnabled } from "@src/appV2/FeatureFlags/useIsCredentialRequirementConfigurationEnabled";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control, useWatch } from "react-hook-form";

import { isAllowRequiredForBooking } from "../isAllowRequiredForBooking";
import { type RequirementMappingFormValues } from "../types";

interface RequiredForBookingFieldProps {
  control: Control<RequirementMappingFormValues>;
}

export function RequiredForBookingField(props: RequiredForBookingFieldProps) {
  const { control } = props;

  const domain = useWatch({ control, name: "domain" });
  const mappingLevel = useWatch({ control, name: "level" });

  const isCredentialRequirementConfigurationEnabled =
    useIsCredentialRequirementConfigurationEnabled();

  const disabled = !isAllowRequiredForBooking({
    domain,
    mappingLevel,
    isCredentialRequirementConfigurationEnabled,
  });

  return (
    <FormFieldController
      name="requiredForBooking"
      control={control}
      label=""
      sx={{ mb: 2 }}
      render={(field) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={field.value}
              disabled={disabled}
              onChange={(event) => {
                field.onChange(event.target.checked);
              }}
              onBlur={field.onBlur}
            />
          }
          label="Required for booking"
        />
      )}
    />
  );
}
